import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useTranslation } from "react-i18next";
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import euLogoOscuro from '../images/EuLogoTransparentOscuro.png';
import rtrLogoOscuro from '../images/Logo_Plan_RTROscuro.png';
import { useUser } from '../hooks/useUser';
import { useConfiguration } from '../hooks/useConfiguration';
import colors from '../theme/colors';
import SvgIcon from '@mui/material/SvgIcon';

const Footer = () => {

    const { t } = useTranslation()
    const [urls, setUrls] = useState()
    const { getURLs } = useUser()
    const { configuration } = useConfiguration()

    useEffect(() => {
        getURLs()
            .then((data) => {
                setUrls(data.links)
            })
    }, [])

    return (
        <>
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={1}
                sx={{
                    bgcolor: colors.bgLight,
                    padding: '1em 0',
                    borderTop: '0.2em solid ' + colors.primary
                }}
            >
                <Box>
                    <Typography variant="parrafoFooter" target="_blank" >
                        {t('footer.teGusta')}
                    </Typography>
                    &nbsp;
                    <Link href={configuration?.url_contacto} variant='linkFooter' target="_blank">{t('footer.tuOpinion')}</Link>
                </Box>
                <Box>
                    <Grid
                        container
                        direction="row"
                        spacing={2}
                    >
                        <Grid
                            item
                            display="flex"
                            justifyContent="space-evenly"
                            alignItems="center"
                            flexWrap={"wrap"}
                            columnGap={4}
                            rowGap={2}

                        >
                            <img src={rtrLogoOscuro} alt="reu" />
                            <img src={euLogoOscuro} alt="eu" />
                            <Box>                             
                                
                                <IconButton color="text" href={urls?.twitter} target="_blank">
                                    <SvgIcon>
                                        <SvgIcon>
                                            <svg
                                                width="21.5" height="21.5" viewBox="0 0 26 26"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 8.6484375 9 L 13.259766 9 L 15.951172 12.847656 L 19.28125 9 L 20.732422 9 L 16.603516 13.78125 L 21.654297 21 L 17.042969 21 L 14.056641 16.730469 L 10.369141 21 L 8.8945312 21 L 13.400391 15.794922 L 8.6484375 9 z M 10.878906 10.183594 L 17.632812 19.810547 L 19.421875 19.810547 L 12.666016 10.183594 L 10.878906 10.183594 z"
                                                />
                                            </svg>
                                        </SvgIcon>
                                    </SvgIcon>
                                </IconButton>
                                <IconButton color="text" href={urls?.facebook} target="_blank">
                                    <FacebookIcon sx={{ color: colors.primary }} />
                                </IconButton>
                                <IconButton color="text" href={urls?.youtube} target="_blank">
                                    <YouTubeIcon sx={{ color: colors.primary }} />
                                </IconButton>
                                <IconButton color="text" href={urls?.linkedin} target="_blank">
                                    <LinkedInIcon sx={{ color: colors.primary }} />
                                </IconButton>
                                <IconButton color="text" href={urls?.rss} target="_blank">
                                    <RssFeedIcon sx={{ color: colors.primary }} />
                                </IconButton>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Stack>
            <Stack width={'100%'} paddingY={2} bgcolor={colors.primary} style={{ textAlign: 'center' }}>
                <Link href={urls?.dgipyme} target="_blank" variant='linkFooter' color={colors.textLink}>{t("footer.direccionGeneral")}</Link>
            </Stack>
        </>
    );
};
export default Footer;

